import React, {Component} from 'react';
import {Col} from "react-grid-system";
import './Card.css';

import Preview from "./Photo";

class Card extends Component {

    render() {
        return (
            <Col sm={4}>
                <div className="Card">
                    <Preview entry={this.props.entry}/>
                    <div className="Card-Title Card-Line"
                         title={this.props.entry.fields['Titre de l\'activité que vous proposez FR']}>
                        {this.props.entry.fields['Titre de l\'activité que vous proposez FR']}
                    </div>
                    <div className="Card-Line">
                        <div className="Card-Line-Title">
                            Catégorie
                        </div>
                        <div className="Card-Line-Value">
                            <span className="label">
                                {this.props.entry.fields['catégorie']}
                            </span>
                        </div>
                    </div>

                    <div className="Card-Line">
                        <div className="Card-Line-Title">
                            Description
                        </div>
                        <div className="Card-Line-Value">
                            {this.props.entry.fields['Description en 4 lignes FR']}
                        </div>
                    </div>
                </div>
            </Col>
        );
    }
}

export default Card;


// WEBPACK FOOTER //
// ./src/Components/Cards/Card.js